/* DEV-449 (2026-09-28, Audrius): "Buy now" on the product page (snippets/buy-buttons.liquid renders the button).
   Tap: the chosen variant (and quantity / properties from the same form) goes into the cart with /cart/add.js, then the
   browser goes to checkout. Items already in the cart stay (no cart permalink). The cart drawer is not opened and no
   cart event is sent. No size chosen yet: the button stays active and the tap gets the same "Please select a size"
   prompt as Add to cart (the size guard in assets/lm-pdp.js listens on the whole buy box). Sold out: disabled like Add to
   cart. An error from /cart/add.js: Add to cart is tapped instead, so the theme shows its own message. A "buy_now_click" event goes to Shopify analytics and dataLayer. */
(() => {
  if (window.__lmBuyNow) return;
  window.__lmBuyNow = true;

  const atcOf = (form) => form.querySelector('buy-buttons button[type="submit"]');

  /* same check as the size guard: the product has a size option and none is chosen */
  const sizeMissing = (form) => {
    const vp = document.querySelector('variant-picker[form-id="' + form.getAttribute('id') + '"]');
    const pos = vp && vp.getAttribute('data-size-position');
    if (!pos || pos === '0') return false;
    return !!vp.querySelector('input[data-option-position="' + pos + '"]') && !vp.querySelector('input[data-option-position="' + pos + '"]:checked');
  };

  /* the button follows Add to cart: disabled together with it (sold out / unavailable variant), but not while Add to cart
     only waits for a size, so the tap can show the size prompt */
  const sync = (button) => {
    const form = button.closest('form');
    const atc = form && atcOf(form);
    if (!atc) return;
    const apply = () => { button.disabled = atc.disabled && !sizeMissing(form); };
    apply();
    new MutationObserver(apply).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
    document.addEventListener('change', () => requestAnimationFrame(apply));
  };

  const track = (form) => {
    const input = form.querySelector('input[name="id"]');
    const detail = { variant_id: input ? input.value : null, url: location.pathname };
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('buy_now_click', detail); } catch (error) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'buy_now_click' }, detail)); } catch (error) {}
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest && event.target.closest('[data-lm-buy-now]');
    if (!button || button.disabled) return;
    const form = button.closest('form');
    if (!form) return;
    track(form);
    /* no size chosen: the size guard has already shown its prompt (event.defaultPrevented) */
    if (event.defaultPrevented || sizeMissing(form)) return;
    const atc = atcOf(form);
    const input = form.querySelector('input[name="id"]');
    if (!input || input.disabled || !input.value) {
      if (atc) atc.click();
      return;
    }
    button.setAttribute('aria-busy', 'true');
    try {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: new FormData(form),
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error(response.status);
      location.assign(root + 'checkout');
    } catch (error) {
      button.removeAttribute('aria-busy');
      if (atc) atc.click(); /* the theme shows its own error (e.g. not enough stock) */
    }
  });

  const boot = () => document.querySelectorAll('[data-lm-buy-now]').forEach((button) => {
    if (button.__lmSync) return;
    button.__lmSync = true;
    sync(button);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* the variant picker re-renders the form (Section Rendering) */
  new MutationObserver(boot).observe(document.documentElement, { childList: true, subtree: true });
})();
